import { Component, OnInit, ViewChild, OnDestroy, Input, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiTransactionService } from '@services/api-transaction.service';
import { SharedService } from '@services/shared.service';
import { TransactionNotesModel } from '@models/TransactionModel';
import { Subscription } from 'rxjs';
import { SweetAlertResult } from 'sweetalert2';
import { Country } from '@shared/models/Enums';

@Component({
  selector: 'app-givi-note-modal',
  templateUrl: './givi-note-modal.component.html',
  styleUrls: ['./givi-note-modal.component.scss']
})
export class GiviNoteModalComponent implements OnInit {

  @Input() giviNote: TransactionNotesModel;
  @Input() countryNote: Country = Country.CR;
  @Input() customerOwnerId: number;
  @Input() transactionId: number;
  @Input() isPackage: boolean = false;
  @ViewChild('showGiviNoteModal', { static: true }) modal: any;

  @Output() onCloseModal: EventEmitter<void> = new EventEmitter<void>();
  @Output() onUpdateNote: EventEmitter<TransactionNotesModel> = new EventEmitter<TransactionNotesModel>(); 

  private showGiviNoteModalSubscription: Subscription = null;


  selectColor: string;
  note: string;

  constructor(private router: Router,
    private modalService: NgbModal,
    public sharedService: SharedService,
    private apiTransactionService: ApiTransactionService) { }

  ngOnInit(): void {
    this.showGiviNoteModalSubscription = this.sharedService.showGiviNoteModal.subscribe(show => {
      if (show) {
        this.openModal();
      }
    });
  }

  ngOnDestroy() {

    if (this.showGiviNoteModalSubscription) { this.showGiviNoteModalSubscription.unsubscribe(); }
  }

  openModal() {

    setTimeout(() => {

      if (this.giviNote != null && this.giviNote != undefined) {
        // Update
        this.selectColor = this.giviNote.color;
        this.note = this.giviNote.note;
      }
      else {
        // Create
        this.selectColor = '';
        this.note = '';
      }

    }, 50);

    const modalRef = this.modalService.open(this.modal, {
      backdrop: 'static', keyboard: false,
      size: 'lg', centered: true, windowClass: 'modal-full'
    });

    modalRef.result.finally(() => {

      this.onCloseModal.emit();
    });
  }

  closeModal() {

    this.selectColor = '';
    this.note = '';
    this.modalService.dismissAll();

  }

  changeColor(color: string) {

    this.selectColor = color;
  }

  saveNote() {

    if (this.selectColor.trim() == '' || this.note.trim() == '') {

      this.sharedService.showErrorAlert(null, 'La nota y el color son requeridos para guardar la información.');
      return;
    }

    if (this.giviNote != null && this.giviNote != undefined) {

      // Update
      this.sharedService.setLoading(true);
      this.giviNote.note = this.note;
      this.giviNote.color = this.selectColor;

      const updateNote = this.isPackage ?
        this.apiTransactionService.updateTransactionPackageNote(this.giviNote, this.countryNote) : 
        this.apiTransactionService.updateTransactionNote(this.giviNote, this.countryNote);

      updateNote.then(
        (transactionNote) => { 

          this.sharedService.setLoading(false);

          // window.location.reload();
          this.onUpdateNote.emit(transactionNote);
          this.closeModal();

        }

      ).catch(err => {

        this.sharedService.setLoading(false);
        this.sharedService.showErrorAlert(null, 'Error al actualizar la nota, vuelve a intentarlo.');
      });
    }
    else {

      // Create
      this.sharedService.setLoading(true);
      this.giviNote = new TransactionNotesModel();
      this.giviNote.transactionId = this.transactionId;
      this.giviNote.customerOwnerId = this.customerOwnerId;
      this.giviNote.note = this.note;
      this.giviNote.color = this.selectColor;

      const createNote = this.isPackage ?
      this.apiTransactionService.createTransactionPackageNote(this.giviNote, this.countryNote) : 
      this.apiTransactionService.createTransactionNote(this.giviNote, this.countryNote);

      createNote.then(
        (transactionNote) => {
          
          this.sharedService.setLoading(false);
          window.location.reload(); 
        }

      ).catch(err => {

        this.sharedService.setLoading(false);
        this.sharedService.showErrorAlert(null, 'Error al actualizar la nota, vuelve a intentarlo.');
      });
    }

  }


}
